export default "__VITE_ASSET__D59B2s7g__"